import { array, nullable, struct } from 'io-ts/Decoder';

import { FilterRequest } from './FilterRequest';
import { SortableColumns } from './SortableColumn';
import { VisibleColumn } from './VisibleColumn';

export const Request = struct({
	filters: nullable(FilterRequest),
	visibleColumns: nullable(array(VisibleColumn)),
	sort: nullable(SortableColumns),
});
